import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Zap } from 'lucide-react';

const FlashSaleBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const dismissed = sessionStorage.getItem('flash-sale-dismissed');
    if (dismissed) setIsVisible(false);
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    sessionStorage.setItem('flash-sale-dismissed', 'true');
  };

  if (!isVisible) return null;

  return (
    <div
      data-testid="flash-sale-banner"
      className="relative w-full py-3 sm:py-3.5 px-3 sm:px-4"
      style={{
        background: 'linear-gradient(90deg, #FF3D00 0%, #FF9500 30%, #FFB300 50%, #FF9500 70%, #FF3D00 100%)',
        backgroundSize: '200% 100%',
        animation: 'flashSaleShift 4s linear infinite',
        borderBottom: '3px solid #C43600',
        boxShadow: '0 4px 24px rgba(255, 61, 0, 0.55)',
      }}
    >
      <style>{`
        @keyframes flashSaleShift {
          0% { background-position: 0% 50%; }
          100% { background-position: 200% 50%; }
        }
      `}</style>
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 sm:gap-4">
        <Zap className="h-5 w-5 sm:h-6 sm:w-6 flex-shrink-0 animate-pulse" style={{ color: '#0C0A09' }} strokeWidth={2.5} />
        <Link
          to="/products"
          className="flex-1 text-center min-w-0"
          style={{ textDecoration: 'none' }}
        >
          <p
            className="text-sm sm:text-base md:text-lg font-extrabold uppercase tracking-wider leading-tight"
            style={{ color: '#0C0A09' }}
          >
            <span className="mr-1">🔥</span>
            FLASH SALE — 15% OFF EVERYTHING
            <span className="ml-1">🔥</span>
          </p>
          <p
            className="text-[10px] sm:text-xs font-bold uppercase tracking-widest mt-0.5"
            style={{ color: '#0C0A09', opacity: 0.85 }}
          >
            Applied automatically at checkout · Kits &amp; BAC water excluded
          </p>
        </Link>
        <Zap className="h-5 w-5 sm:h-6 sm:w-6 flex-shrink-0 animate-pulse" style={{ color: '#0C0A09' }} strokeWidth={2.5} />
        <button
          onClick={handleDismiss}
          className="flex-shrink-0 p-1.5 rounded-full transition-all hover:bg-black/10"
          aria-label="Close banner"
          data-testid="close-flash-sale-banner"
        >
          <X className="h-4 w-4 sm:h-5 sm:w-5" style={{ color: '#0C0A09' }} strokeWidth={2} />
        </button>
      </div>
    </div>
  );
};

export default FlashSaleBanner;
